// @flow

import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';
import { ClickTracker } from '@ta/common.tracking';
import EventBoundary from '@ta/events.event-boundary';

import BreadcrumbsItem from './BreadcrumbsItem';

export type BreadcrumbProps = {
  /*
   * Display name of the breadcrumb item
   */
  name: string,

  /*
   * URL for the breadcrumb item
   */
  href: string,

  /**
   * Place type of this breadcrumb item (needed for tracking)
   */
  placeType: string,
  /**
   * Crumb index, used for tracking
   */
  crumbIndex: number,
};

type Props = {|
  breadcrumbs: Array<BreadcrumbProps>,

  /**
   * If true, this appears over a solid background rather than an imaage, so we should simplify
   * the style
   */
  flat?: boolean,
|};

const BreadcrumbsList = ({ breadcrumbs, flat = false }: Props) => (
  <EventBoundary events={['onClick']}>
    {breadcrumbs.map((crumb, index) => {
      const isLastItem = index + 1 === breadcrumbs.length;
      const trackingContext =
        isLastItem && featureIsEnabled('breadcrumbs_as_global_nav') ? 'openMenu' : crumb.placeType;
      return (
        <ClickTracker
          module="Breadcrumbs"
          action="click"
          context={trackingContext}
          value={crumb.crumbIndex}
          key={crumb.crumbIndex}
          useSpan
        >
          <BreadcrumbsItem
            displayName={crumb.name}
            href={crumb.href}
            isLastItem={isLastItem}
            flat={flat}
          />
        </ClickTracker>
      );
    })}
  </EventBoundary>
);

export default BreadcrumbsList;
